import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import parse from 'html-react-parser';
import React from "react";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});


const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    marginBottom: 0,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black',
    padding: 10
  },
  boldText: {
    fontFamily: 'Roboto',
    fontSize: 6,
    fontSize: '10px',
    marginTop: '1%',
    marginLeft: '4%'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 0,
    padding: 5,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black'
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5,
    minHeight: '100px'
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '12.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: 'navy',
    color: 'white'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: 'navy',
    color: 'white'
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    marginLeft: 25,
    marginRight: 25
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  },
  parsedContent: {
    marginTop: 10,
    marginBottom: 5,
    fontSize: 10,
    textAlign: 'justify',
    padding: 10
  },
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const DischargeSummaryPDF = ({ data, isPublic = false }) => {
  const [barcodeImg, setBarcodeImg] = React.useState("");
  const [qrImg, setQrImg] = React.useState("");
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [isDownloaded, setIsDownloaded] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const medicines = data?.medicines || [];
  const user = JSON.parse(localStorage.getItem('user'));
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const formatRegTime = (time) => {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    // Format to 12-hour time
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return date.toLocaleTimeString('en-US', options);
  };

  const parseHtmlToPdfText = (html) => {
    return parse(html, {
      replace: (domNode) => {
        if (domNode.type === 'tag') {
          switch (domNode.name) {
            case 'strong':
              // Render bold text correctly
              return (
                <PDFText style={{ ...styles.boldText, fontFamily: 'Roboto', marginBottom: 3 }}>
                  {domNode.children.map((child) => child.data).join('')}
                </PDFText>
              );
            case 'p':
              // Handle <p> tags and render the text within them
              return (
                <PDFText style={{ ...styles.text, marginBottom: 10 }}>
                  {domNode.children
                    .map((child) => {
                      if (child.type === 'text') {
                        return child.data.trim(); // Handle plain text
                      }
                      if (child.type === 'tag' && child.name === 'strong') {
                        return child.children.map((strongChild) => strongChild.data).join(''); // Handle strong tags
                      }
                      return ''; // Handle any other types of nodes
                    })
                    .join(' ')}
                </PDFText>
              );

            // Handle header tags (h1, h2, h3, h4, h5, h6)
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return (
                <PDFText style={{ ...styles.headerText, fontFamily: 'Roboto', marginBottom: 5 }}>
                  {domNode.children.map((child) => child.data).join('')}
                </PDFText>
              );

            case 'figure':
              // Handle the <figure> tag, which contains the table
              return (
                <PDFView style={styles.figure}>
                  {domNode.children.map((child, childIndex) => {
                    if (child.name === 'table') {
                      // If we encounter a table within the <figure> tag, render it
                      return (
                        <PDFView style={styles.table} key={childIndex}>
                          {child.children.map((tbody, tbodyIndex) => {
                            if (tbody.name === 'tbody') {
                              // Process the rows within <tbody>
                              return (
                                <PDFView style={styles.tableBody} key={tbodyIndex}>
                                  {tbody.children.map((row, rowIndex) => {
                                    if (row.name === 'tr') {
                                      // For each row, render each cell
                                      return (
                                        <PDFView style={styles.tableRow} key={rowIndex}>
                                          {row.children.map((cell, cellIndex) => {
                                            if (cell.name === 'td' || cell.name === 'th') {
                                              // Handle <td> and <th> cells
                                              return (
                                                <PDFView style={styles.tableCell} key={cellIndex}>
                                                  {cell.children.map((child, childIndex) => {
                                                    // Check if the child is a <p> tag inside <td>
                                                    if (child.name === 'p') {
                                                      // Render <p> as a paragraph inside the cell
                                                      return (
                                                        <PDFText style={{ ...styles.text, marginBottom: 10 }} key={childIndex}>
                                                          {child.children.map((pChild) => pChild.data).join('')}
                                                        </PDFText>
                                                      );
                                                    }
                                                    if (child.type === 'text') {
                                                      // Handle plain text
                                                      return (
                                                        <PDFText style={{ ...styles.text, marginBottom: 10 }} key={childIndex}>
                                                          {child.data.trim()}
                                                        </PDFText>
                                                      );
                                                    }
                                                    return null; // Skip non-text elements
                                                  })}
                                                </PDFView>
                                              );
                                            }
                                            return null; // Skip non-cell elements
                                          })}
                                        </PDFView>
                                      );
                                    }
                                    return null; // Skip non-row elements
                                  })}
                                </PDFView>
                              );
                            }
                            return null; // Skip non-body elements
                          })}
                        </PDFView>
                      );
                    }
                    return null; // Skip non-table elements
                  })}
                </PDFView>
              );

            case 'ol':
              // Handle the <ol> (ordered list) tag
              return (
                <PDFView style={styles.orderedList}>
                  {domNode.children.map((li, liIndex) => {
                    if (li.name === 'li') {
                      // For each <li> in the <ol>, render a list item with index
                      return (
                        <PDFView style={styles.listItem} key={liIndex}>
                          <PDFText style={{ ...styles.listItemText, marginBottom: 10 }}>
                            {/* Manually add the index */}
                            {`${liIndex + 1}. `}
                            {li.children.map((child) => child.data).join('')}
                          </PDFText>
                        </PDFView>
                      );
                    }
                    return null; // Skip non-list-item elements
                  })}
                </PDFView>
              );

            case 'li':
              // Handle <li> (list item) outside of <ol>
              return (
                <PDFView style={styles.listItem}>
                  <PDFText style={{ ...styles.listItemText, marginBottom: 10 }}>
                    {domNode.children.map((child) => child.data).join('')}
                  </PDFText>
                </PDFView>
              );

            default:
              // For any other elements, just return the text
              return <PDFText style={{ ...styles.text, marginBottom: 10 }}>{domNode.data}</PDFText>;
          }
        }
      }
    });
  };

  React.useEffect(() => {
    if (!data || typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);
    const refId = params.get("refId");

    // BARCODE
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, String(data.ipd_no), {
      format: "CODE128",
      displayValue: false,
      height: 40
    });
    setBarcodeImg(canvas.toDataURL());
    let path;
    // QR → PUBLIC LINK
    if (refId) {
      if (isPublic) {
        path = window.location.pathname;
      } else {
        path = window.location.pathname.replace("/print/", "/public/print/");
      }
      const qrUrl = `${window.location.origin}${path}?refId=${refId}`;
      QRCode.toDataURL(qrUrl).then(setQrImg);
    }
  }, [data]);


  const downloadPDF = async () => {
    try {
      // Import pdf dynamically to avoid SSR issues
      const { pdf } = await import('@react-pdf/renderer');
      const blob = await pdf(PdfDoc).toBlob();
      const url = URL.createObjectURL(blob);

      // Create download link
      const link = document.createElement('a');
      link.href = url;
      link.download = `Discharge-Summary-${data.receiptNo || Date.now()}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      setTimeout(() => {
        URL.revokeObjectURL(url);
        setIsDownloading(false);

        // Show success message instead of trying to close
        setIsDownloaded(true);
      }, 100);

    } catch (error) {
      console.error('Error downloading PDF:', error);
      setIsDownloading(false);
      setIsError(true);
      //alert('Failed to download PDF. Please try again.');
    }
  };


  React.useEffect(() => {
    if (isPublic && data && barcodeImg && qrImg && !isDownloading) {
      // Small delay to ensure everything is loaded
      const timer = setTimeout(() => {
        downloadPDF();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isPublic, data, barcodeImg, qrImg, isDownloading]);




  const PdfDoc = (
    <Document title={`Discharge Summary`}>
      <Page size="A4" style={styles.page}>
        <PDFImage
          src="/logo_Hospital_m.jpeg"
          style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
        />
        <View style={styles.row}>
          <Text content="Discharge Summary" style={{ fontSize: '12px', margin: '0 auto', fontFamily: 'Roboto' }} />
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginVertical: 10
          }}
        >
          {barcodeImg && (
            <PDFImage src={barcodeImg} style={{ width: 130, height: 40 }} />
          )}

          {qrImg && (
            <PDFImage src={qrImg} style={{ width: 70, height: 70 }} />
          )}
        </View>
        <View style={styles.contentContainer}>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="Patient Name          :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data.name || ''}`} />
            </View>
            <View style={styles.row}>
              <Text
                content="Address                   :    "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${data.address || ''}`} />
            </View>
            <View style={styles.row}>
              <Text
                content="UHID No.                  :     "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${data.uhid || ''}`} />
            </View>
            <View style={styles.row}>
              <Text
                content="Mob No.                   :    "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${data.mobile || ''}`} />
            </View>
            <View style={styles.row}>
              <Text
                content="Admission Date      :             "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${formatDate(data.date) || ''} ${formatRegTime(data.time) || ''}`} />
            </View>
            <View style={styles.row}>
              <Text
                content="Room No.                 :      "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${data.room_no || ''}`} />
            </View>
          </View>
          <View style={styles.column}></View>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="Consultant           :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data.consultant || ''}`} />
            </View>
            <View style={styles.row}>
              <Text content="Age/Sex               :      " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data.age || ''} / ${data.gender || ''}`} />
            </View>
            <View style={styles.row}>
              <Text content="IPD No.                 :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data.ipd_no || ''}`} />
            </View>
            <View style={styles.row}>
              <Text content="Discharge Date    :      " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${formatDate(data.dis_date) || ''} ${formatRegTime(data?.patientDischarge?.time) || ''}`} />
            </View>
            <View style={styles.row}>
              <Text
                content="Ward                      :      "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${data.ward_name || ''}`} />
            </View>
            <View style={styles.row}>
              <Text content="Discharge Mode  :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.patient_details?.discharge_mode || ''}`} />
            </View>
            <View style={styles.row}>
              <Text content="Department          :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data.department || ''}`} />
            </View>
          </View>
        </View>
        {data.diagnos && data.diagnos.length > 0 ? (
          data.diagnos.map((item, index) => (
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text
                    content="Add Diagnos                        :      "
                    style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                  />
                  <Text content={`${item.add_diagnos || ''}`} />
                </View>
              </View>
            </View>
          ))
        ) : (
          <View style={{ ...styles.row, padding: '5px' }}>
            <Text style={{ ...styles.columnText, width: '100%' }}>No diagnosis available</Text>
          </View>
        )}

        {data.other_details.final_diagnosis && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Final Diagnosis                    :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.final_diagnosis || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.chief_complaints && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Chief Complaints                 :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.chief_complaints || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.past_history && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Past History                         :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.past_history || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.history && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="History                                 :       "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.history || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.personal_history && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Personal History                  :     "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.personal_history || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.other_investigation && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Other Investigation              :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.other_investigation || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.surgery_detail && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Surgery Details                   :       "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.surgery_detail || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.course_in_hospital && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Course In Hospital              :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.course_in_hospital || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.condition_at_discharge && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Condition At Discharge       :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.condition_at_discharge || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.other_details.medicine && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Medicine                               :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.other_details?.medicine || ''}`} />
              </View>
            </View>
          </View>
        )}

        <View style={{ ...styles.contentContainer2, height: '130px', flexDirection: 'row' }}>
          <View style={{ backgroundColor: 'blue' }}>
            <Text
              content="Clinical Examinations"
              style={{ width: '100%', textAlign: 'center', fontFamily: 'Roboto' }}
            />
          </View>
          {/* First Column */}
          <View style={{ ...styles.column, marginTop: '5%', marginLeft: '30px' }}>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Consiousness Level: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.consiouness_level || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Abdomen: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.abdomen || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Blood Pressure(Systolic): " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.blood_pressure_systolic || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Blood Pressure(Diastolic): " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.blood_pressure_diastolic || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Pluse: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.pulse || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Chest: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.chest || ''}`} />
            </View>
          </View>

          {/* Second Column */}
          <View style={{ ...styles.column, marginLeft: '20px', marginTop: '5%' }}>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="CNS: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.cns || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="CVS: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.cvs || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Temperature: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.temprature || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Respiratory Rate: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.respiratory_rate || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Local Examination: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.local_examination || ''}`} />
            </View>
            <View style={{ ...styles.row, alignItems: 'center' }}>
              <Text content="Any Other: " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.clinical_examination?.any_other || ''}`} />
            </View>
          </View>
        </View>
        {data.lab.lab_investigation && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Lab                             :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.lab?.lab_investigation || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.radiology.radiology && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Radiology                  :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.radiology?.radiology || ''}`} />
              </View>
            </View>
          </View>
        )}

        {/* Table */}
        <View style={styles.headerContainer}>
          <Text content="S. No." style={styles.columnTextNarrow} />
          <Text content="Discharge Medicine" style={{ ...styles.columnText, width: '20%' }} />
          <Text content="Frequency" style={styles.columnTextWide} />
          <Text content="Morning" style={styles.columnText} />
          <Text content="Noon" style={styles.columnText} />
          <Text content="Evening" style={styles.columnText} />
          <Text content="Night" style={styles.columnText} />
          <Text content="Days" style={styles.columnText} />
        </View>
        {data.medicine && data.medicine.length > 0 ? (
          data.medicine.map((item, index) => (
            <View
              style={{
                ...styles.row,
                backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                marginTop: 5,
                padding: '5px'
              }}
              key={index}
            >
              <Text content={index + 1} style={{ ...styles.columnTextNarrow }} />
              <Text content={item.name || '-'} style={{ ...styles.columnText, width: '20%' }} />
              <Text content={item.frequency_id?.frequency || '-'} style={{ ...styles.columnText, width: '22%' }} />
              <Text content={item.morning === 'true' ? 'YES' : '' || ''} style={styles.columnText} />
              <Text content={item.noon === 'true' ? 'YES' : '' || ''} style={styles.columnText} />
              <Text content={item.evening === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText }} />
              <Text content={item.night === 'true' ? 'YES' : '' || ''} style={{ ...styles.columnText }} />
              <Text content={item.days || '0'} style={{ ...styles.columnText }} />
            </View>
          ))
        ) : (
          <View style={{ ...styles.row }}>
            <Text content="No receipts found" style={styles.columnTextNarrow} />
            <Text content="-" style={styles.columnText} />
            <Text content="-" style={styles.columnTextWide} />
            <Text content="-" style={styles.columnText} />
            <Text content="0" style={{ ...styles.columnText, width: '20%' }} />
          </View>
        )}
        {data.advice_on_discharge.doctor_advice && (
          <View style={{ ...styles.contentContainer2, marginTop: '10%' }}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Doctor Advise                  :         "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.advice_on_discharge?.doctor_advice || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.advice_on_discharge.emergency_contact_details && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Emergency Contact Details           :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.advice_on_discharge?.emergency_contact_details || ''}`} />
              </View>
            </View>
          </View>
        )}
        {data.advice_on_discharge.diet_plan && (
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Diet Plan                           :      "
                  style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                />
                <Text content={`${data?.advice_on_discharge?.diet_plan || ''}`} />
              </View>
            </View>
          </View>
        )}


        {data?.general_examination && <View style={styles.parsedContent}>{parseHtmlToPdfText(data.general_examination)}</View>}
        <View style={styles.contentContainer}>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text
                content="Prepared By                   :     "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${data?.createdBy || ''}`} />
            </View>
            <View style={styles.row}>
              <Text
                content="Next Follow Time          :        "
                style={{ ...styles.textBold, fontFamily: 'Roboto' }}
              />
              <Text content={`${data?.next_follow_up || ''} Days`} />
            </View>
          </View>
          <View style={styles.column}></View>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="(Doctor Name) :" style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
              <Text content={`${data?.consultant || ''}`} />
            </View>
            <View style={styles.row}>
              <Text content="Consultant Doctor & Sign:" style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        {PdfDoc}
      </PDFViewer>
    </div>
  );
};
